"use client";

import styles from "./Spinner.module.scss";

const Spinner = () => {
  return <div className={styles["comp"]} />;
};

export { Spinner };
